import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BaiduMap from 'vue-baidu-map'
import './assets/scss/style.scss'

Vue.use(BaiduMap,{
  ak: 'XIp63Usvmfyeh2h3PKH4loGuRcWPVWcD'
})
Vue.config.productionTip = false

window.VM = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

